angular.module('ihestiaWidgets.policyDetails')
  .controller('ihestiaLifePersonEditModalCtrl', ['$scope', 'ihestiaLifePersonEditModalHelper', function($scope, ihestiaLifePersonEditModalHelper) {
    ihestiaLifePersonEditModalHelper.init();
    $scope.tplData = ihestiaLifePersonEditModalHelper.tplData;
    $scope.personEditForm = ihestiaLifePersonEditModalHelper.personEditForm;
  }]);
